module.exports = __webpack_public_path__ + "static/media/Fibra Cracked Wheat.70c45e06.png";